import { DateTime } from 'src_common/utils/time/time';

/**
 * Serializable payload embedded in HTML (`data-socket-bootstrap`) and applied
 * into SocketMaps on SSR + client before first observe.
 *
 * HTML may be wire-slim (omit unused null/empty decoder fields). applyHrNextOffBootstrap
 * expands defaults before io-ts decode.
 *
 * L1 (required): queryKey + eventList
 * L2 (optional, HR next-off): events + eventMarkets + markets
 */
export type SocketBootstrapPayload = {
    queryKey: string;
    from: string;
    to: string;
    /** Raw EventListGroup shape (pre-convertEventListGroup) */
    eventList: unknown;
    /** Raw event payloads (HTTP / WS ModelEvent body) */
    events?: Array<unknown>;
    /** Raw event-markets index per event */
    eventMarkets?: Array<{
        eventId: number;
        markets: unknown;
    }>;
    /** Raw MarketApiModel payloads (incl. selections map) */
    markets?: Array<unknown>;
};

export type NextOffRacingRange = { from: string; to: string };

export const computeDefaultNextOffRacingRange = (): NextOffRacingRange => ({
    from: DateTime.current().subtractHours(2).startOfHours().toISOString(),
    to: DateTime.current().addHours(24).startOfHours().toISOString(),
});
